import React, { useEffect } from 'react';
import type { ArchiveItem } from '../types';
import ArchiveTable from './ArchiveTable';
import ArchiveInlineNotice from './ArchiveInlineNotice';
import { useArchiveActions } from './useArchiveActions';
import { approveAllEventName, dismissAllEventName } from './constants';

interface Props {
  items: ArchiveItem[];
}

export default function ArchiveBody({ items }: Props): React.ReactElement {
  const { decoratedItems, notice, archive, dismiss, undo, archiveAll, dismissAll } =
    useArchiveActions(items);

  useEffect(() => {
    const approveHandler = () => archiveAll();
    const dismissHandler = () => dismissAll();
    const approveEvent = approveAllEventName('archive');
    const dismissEvent = dismissAllEventName('archive');
    window.addEventListener(approveEvent, approveHandler);
    window.addEventListener(dismissEvent, dismissHandler);
    return () => {
      window.removeEventListener(approveEvent, approveHandler);
      window.removeEventListener(dismissEvent, dismissHandler);
    };
  }, [archiveAll, dismissAll]);

  return (
    <>
      {notice && <ArchiveInlineNotice notice={notice} onUndo={undo} />}
      {decoratedItems.length === 0 ? (
        <div className="mt-5 bg-white border border-lineSoft rounded-lg px-6 py-12 text-center text-helper text-small">
          All suggestions reviewed. Nothing left to archive right now.
        </div>
      ) : (
        <ArchiveTable items={decoratedItems} onArchive={archive} onDismiss={dismiss} />
      )}
    </>
  );
}